module.exports = __webpack_public_path__ + "img/apple_download_all.3186d686.png";